import { JSONTree } from "react-json-tree"
import { getJsonTheme } from "../utils/themes"
import { useTheme } from "./ThemeProvider"

type ToolOutputProps = {
  output: unknown
}

function isJsonObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}

function isJsonArray(value: unknown): value is unknown[] {
  return Array.isArray(value)
}

export default function ToolOutput({ output }: ToolOutputProps) {
  const { theme } = useTheme()
  const jsonTheme = getJsonTheme(theme)

  // Handle null/undefined
  if (output === null || output === undefined) {
    return <span className="text-xs text-muted-foreground italic">No output</span>
  }

  // Handle JSON objects and arrays with tree view
  if (isJsonObject(output) || isJsonArray(output)) {
    return (
      <div className="max-h-[300px] overflow-auto text-xs">
        <JSONTree
          data={output}
          theme={jsonTheme}
          invertTheme={false}
          hideRoot
          shouldExpandNodeInitially={(_keyPath, _data, level) => level < 2}
        />
      </div>
    )
  }

  // Handle primitive values (string, number, boolean)
  return <span className="text-xs font-mono whitespace-pre-wrap break-all">{String(output)}</span>
}
